import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import * as _ from 'lodash';

import {ManualPayment} from '@appModels/core-accounting/manual-payment/manual-payment';
import {
  ManualPaymentActions,
  ManualPaymentActionTypes
} from '@appStore/actions/core-accounting/manual-payment/manual-payment.actions';

export interface State extends EntityState<ManualPayment> {
  loaded: boolean;
  loading: boolean;
  error: any;
  selectedManualPaymentId: number;
  searchManualPayments: ManualPayment[];
  paging: any;
}

export const adapter: EntityAdapter<ManualPayment> = createEntityAdapter<ManualPayment>();

export const initialState: State = adapter.getInitialState({
  loaded: false,
  loading: false,
  selectedManualPaymentId: null,
  error: null,
  searchTerm: '',
  searchManualPayments: null,
  paging: null
});

export function reducer(state = initialState, action: ManualPaymentActions): State {
  switch (action.type) {
    case ManualPaymentActionTypes.manualPaymentGetManualPayments:
    case ManualPaymentActionTypes.manualPaymentAddManualPayment:
    case ManualPaymentActionTypes.manualPaymentUploadManualPayment:
    case ManualPaymentActionTypes.manualPaymentUploadManualPaymentSuccess:
    case ManualPaymentActionTypes.manualPaymentDeleteManualPayment:
    case ManualPaymentActionTypes.manualPaymentUpdateManualPayment:
    case ManualPaymentActionTypes.manualPaymentSearchManualPayments:
    case ManualPaymentActionTypes.manualPaymentGetManualPaymentById:
      return {
        ...state,
        loading: true
      };

    case ManualPaymentActionTypes.manualPaymentGetManualPaymentsSuccess:
      return adapter.setAll(action.payload.content, {
        ...state,
        loading: false,
        loaded: true,
        paging: _.omit(action.payload, ['content'])
      });

    case ManualPaymentActionTypes.manualPaymentGetManualPaymentByIdSuccess:
      return { ...state, selectedManualPaymentId: action.payload.id, loading: false };

    case ManualPaymentActionTypes.manualPaymentAddManualPaymentSuccess:
      return adapter.addOne(action.payload, {
        ...state,
        error: null,
        loading: false,
        loaded: true
      });
    case ManualPaymentActionTypes.manualPaymentUpdateManualPaymentSuccess: {
      return adapter.updateOne(
        {
          id: action.payload.id,
          changes: action.payload
        },
        {
          ...state,
          loading: false,
          loaded: true
        }
      );
    }

    case ManualPaymentActionTypes.manualPaymentDeleteManualPaymentSuccess: {
      return adapter.removeOne(action.payload.id, {
        ...state,
        loading: false,
        loaded: true
      });
    }

    case ManualPaymentActionTypes.manualPaymentSearchManualPaymentsSuccess:
      return {
        ...state,
        searchManualPayments: action.payload,
        loading: false
      };

    case ManualPaymentActionTypes.manualPaymentSearchManualPaymentsReset:
      return {
        ...state,
        searchManualPayments: null
      };

    case ManualPaymentActionTypes.manualPaymentError:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload
      };

    default:
      return state;
  }
}

export const manualPaymentEntitySelectors = adapter.getSelectors();
